const state = () => ({
    list: [],
    loading: false
})

const getters = {}

const actions = {
    async get({commit}) {
        commit('setLoading', true)
        try {
            const res = await this._vm.axios.get(this._vm.endpoints['module_note_trash'], {
                params: {page_limit: 9999}
            })
            const {data} = res.data
            commit('setList', data || [])
        } catch (error) {
            this._vm.onResponseFailure(error.response?.data)
        } finally {
            commit('setLoading', false)
        }
    },

    async restore({commit, dispatch}, {id, restoreCategory}) {
        try {
            const res = await this._vm.axios.post(
                this._vm.endpoints['module_note_trash_restore'],
                {restore_category: restoreCategory ?? false},
                { urlVars: { id } }
            )
            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response?.data)
        }
    },

    async permanentDelete({commit, dispatch}, {id}) {
        try {
            const res = await this._vm.axios.delete(
                this._vm.endpoints['module_note_trash_delete'],
                { urlVars: { id }, _ignoreErrors: ['record_not_found'] }
            )
            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response?.data)
        }
    },
}

const mutations = {
    setLoading(state, val) {
        state.loading = val
    },
    setList(state, data) {
        state.list = data
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
